module.exports = __webpack_public_path__ + "img/jeep-4xe-logo-lockup.66393bbd.png";